import { css } from 'linaria';
import { breakpoints } from '../../../../../../media';

export const categoryCard = css`
	${breakpoints.only.mobile} {
		padding: 0;
		border: none;
		border-radius: 0;
	}
`;

export const imgStyles = css`
	width: calc(100% + 32px);
	min-height: 165px;
	max-height: 165px;
	margin-top: -16px;
	margin-bottom: 8px;
	border-radius: 8px 8px 0 0;
	margin-inline: -16px;
	object-fit: cover;

	${breakpoints.only.mobile} {
		min-width: 140px;
		max-width: 140px;
		min-height: 142px;
		max-height: 142px;
		margin-right: 4px;
		margin-left: 0;
		border-radius: 8px;
		margin-block: 0;
	}
`;
